module.exports = __webpack_public_path__ + "static/media/Kayil.17b8265b.jpg";